import React, { useEffect, useState } from "react";
import './Popup.scss';
import { cdnImage } from "../../helper/constants";

const PopUp = ({ handleClose ,data}) => {

    const acceptedBtn = () => {
        localStorage.setItem('privacy-policy-accepted', true);
        handleClose();
    }

    return (<>
        <div id="privacy_popup" className="privacyModal close-popup">
            <div className="privacy-content">
                <div className="privacy-header">
                    <h4>
                        <img src={`${cdnImage}assets/icons/paper_icon.svg`}/>
                        {data?.title} </h4> 
                </div>
                <div className="privacy-body">
                   <p>{data?.description}</p>
                    {Array.isArray(data?.tnc?.content1) && <ul>{  data?.tnc?.content1?.map ( item =>   <li>{item}</li>)}</ul>}
                     <p> {data?.tnc?.privacy?.text} <a target="_blank" href={`${data?.tnc?.privacy?.link}`}>{data?.tnc?.privacy?.linkText}</a></p>
                </div>
                <div className="privacy-footer">
                    <button className="privacy_btn" onClick={acceptedBtn}>
                        {data?.tnc?.action1}
                    </button>
                    <button className="privacy_btn" onClick={acceptedBtn}>
                        {data?.tnc?.action2}
                    </button>


                </div>


            </div>
        </div>

    </>)
}
export default PopUp